import gql from "graphql-tag";
const getShareQuery = gql(` 
query getShare($key: String!) {
  getShare(key: $key) {
      params
  } 
}   
`)
export default getShareQuery;
